import { render, staticRenderFns } from "./otherDeviceHeaderInfo.vue?vue&type=template&id=7ff5c4f6&scoped=true&"
import script from "./otherDeviceHeaderInfo.vue?vue&type=script&lang=js&"
export * from "./otherDeviceHeaderInfo.vue?vue&type=script&lang=js&"
import style0 from "./otherDeviceHeaderInfo.vue?vue&type=style&index=0&id=7ff5c4f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff5c4f6",
  null
  
)

export default component.exports